// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSessionRevokeAllOthersBody = {};

export type typeSessionRevokeAllOthersOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { revokedCount: number };
};

export type typeSessionRevokeAllOthersOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRevokeAllOthersOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSessionRevokeAllOthersOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSessionRevokeAllOthersBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSessionRevokeAllOthers(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSessionRevokeAllOthersBody);
  }

  return async function postSessionRevokeAllOthers(
    payload: typeSessionRevokeAllOthersBody,
  ): Promise<
    typeSessionRevokeAllOthersOutput200 | typeSessionRevokeAllOthersOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSessionRevokeAllOthers" failed before calling the network. #c109f8448d31`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#c109f8448d31" },
        },
        data: null,
      } as typeSessionRevokeAllOthersOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/session/revoke-all-others`,
      httpMethod: "POST",
      options,
    })) as
      typeSessionRevokeAllOthersOutput200 | typeSessionRevokeAllOthersOutput400;
  };
}
